<template>
  <div>
    <div v-show="exactRoute">
      <v-card>
        <v-card-title>
          Hostitelé
          <v-spacer></v-spacer><v-form v-model="searchValid" class="d-flex align-center">
          <v-text-field
            ref="searchInput"
            v-model.trim="search"
            append-icon="mdi-magnify"
            :rules="[validation.required]"
            label="Vyhledat"
            single-line
            hide-details
            outlined
            dense
            class="rounded-0"
          ></v-text-field>
          <v-select
            outlined
            class="rounded-0"
            dense
            single-line
            hide-details
            ref="searchTypeInput"
            label="Vyhledat podle"
            :rules="[validation.required]"
            v-model="searchType"
            :items="searchTypes"
          >
          </v-select>
          <v-btn
            color="primary"
            :disabled="!searchValid || runningRequest"
            @click="filterBySearch"
            class="rounded-0"
          >Vyhledat</v-btn>
          <v-btn
            color="error"
            @click="resetSearch()"
            class="rounded-0"
            :disabled="!activeSearch || runningRequest"
          >
            Zrušit filtr
          </v-btn>
        </v-form>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="hosts"
          :loading="runningRequest"
          class="elevation-1"
          :server-items-length="totalHosts"
          :options.sync="options"
          :footer-props="{'items-per-page-options': [10, 20, 50] }"
        >
          <template v-slot:item.actions="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="archive(item)"
            >
              mdi-delete
            </v-icon>
            <v-icon
              small
              class="mr-2"
              @click="redirectToDetail(item)"
            >
              mdi-information-variant
            </v-icon>
            <v-icon
              v-if="!item.emailVerifiedAt"
              @click="showVerifyDialog(item)"
            >
              mdi-account-check
            </v-icon>
          </template>
          <template v-slot:item.street="{ item }">
            {{item.street}} {{item.streetNumber}}
          </template>
        </v-data-table>
      </v-card>
      <v-dialog
        width="350"
        v-model="deleteDialog">
        <DeleteResource
          v-if="deleteDialog"
          :resource="hostToDelete"
          resource-type="admin/hosts"
          @delete-success="deleteSuccess"
          @delete-failure="deleteFailure"
        />
      </v-dialog>
      <v-dialog
        v-model="verifyDialog"
        :dismissable="verifyRequest"
        width="350">
        <v-card>
          <v-card-actions>
            <v-btn
              :loading="verifyRequest"
              color="success"
              @click="verify"
            >
              Potvrdit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <router-view ref="childView"></router-view>
  </div>
</template>

<script>
import DeleteResource from '@/components/DeleteResource'
import archiveHelpers from '@/mixins/local/archiveHelpers'
import { mapActions } from 'vuex'
export default {
  name: 'Hosts',
  mixins: [archiveHelpers],
  components: { DeleteResource },
  data () {
    return {
      search: '',
      searchType: null,
      activeSearch: false,
      searchValid: true,
      headers: [
        { text: 'Jméno', align: 'start', value: 'firstName' },
        { text: 'Příjmení', value: 'lastName' },
        { text: 'ID', value: 'id' },
        { text: 'Email', value: 'email' },
        { text: 'Telefon', value: 'phone' },
        { text: 'Telefon 2', value: 'phone2' },
        { text: 'Ulice a čp.', value: 'street' },
        { text: 'PSČ', value: 'zip' },
        { text: 'Město', value: 'city' },
        {
          text: 'Počet objektů',
          value: 'propertiesCount'
        },
        {
          text: 'Kredity',
          value: 'credit'
        },
        {
          text: 'Akce',
          value: 'actions',
          sortable: false
        }
      ],
      hosts: [],
      totalHosts: 0,
      options: {},
      searchTypes: [],
      runningRequest: false,
      exactRoute: true,
      hostToDelete: {},
      userToVerify: {},
      verifyDialog: false,
      verifyRequest: false
    }
  },
  watch: {
    options: {
      deep: true,
      handler () {
        this.loadHosts()
      }
    },
    '$route.params': {
      deep: true,
      handler (newVal, oldVal) {
        // reload pri prechodu z detailu na prehled
        if (oldVal.id && !newVal.id) {
          this.getHosts()
        }
      }
    }
  },
  methods: {
    loadHosts () {},
    getHosts () {
      this.runningRequest = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      this.$http.get('/admin/hosts', {
        params: {
          sortBy: sortBy.length ? sortBy[0] : null,
          sortDesc: sortDesc.length ? sortDesc[0] : null,
          search: this.search,
          // eslint-disable-next-line no-extra-boolean-cast
          searchType: !!this.searchType ? this.searchType : null,
          page,
          itemsPerPage
        }
      })
        .then(res => {
          this.hosts = res.data.hosts
          this.totalHosts = +res.data.total
        })
        .finally(() => {
          this.runningRequest = false
        })
    },
    filterBySearch () {
      this.activeSearch = true
      this.getHosts()
    },
    resetSearch () {
      this.$refs.searchInput.reset()
      this.$refs.searchTypeInput.reset()
      this.activeSearch = false
      this.getHosts()
    },
    redirectToDetail (host) {
      this.$router.push(`/admin/hosts/${host.id}`)
    },
    archive (host) {
      this.hostToDelete = { ...host }
      this.deleteDialog = true
    },
    deleteSuccess () {
      this.showDeleteSuccess()
      this.getHosts()
    },
    verify () {
      this.verifyRequest = true
      this.$http.post(`/admin/users/${this.userToVerify.id}/verify`)
        .then(res => {
          this.verifyDialog = false
          this.verifyRequest = false
          this.setAlerts([{
            message: 'Hostitel ověřen',
            type: 'success'
          }])
          this.getHosts()
        })
    },
    showVerifyDialog (user) {
      this.verifyDialog = true
      this.userToVerify = user
    },
    ...mapActions({
      setAlerts: 'alerts/setAlerts'
    })
  },
  mounted () {
    this.searchTypes = this.headers.slice(0, -3)
    this.getHosts()
    this.loadHosts = this.debounce(this.getHosts, 2000)
    this.exactRoute = typeof this.$refs.childView === 'undefined'
  },
  updated () {
    this.exactRoute = typeof this.$refs.childView === 'undefined'
  }
}
</script>

<style scoped>

</style>
